import * as THREE from 'three';

/**
 * Soft additive glow halo for boss energy cores (Tesla coil, aether core, clockwork heart,
 * maelstrom turbine, juggernaut maw). Bright + additive so the scene bloom turns it into a
 * pulsing energy aura. Attach as a child of the core mesh; call `pulseGlow` from the boss
 * update for the throb.
 */
let glowTex: THREE.Texture | null = null;
function tex(): THREE.Texture {
  if (glowTex) return glowTex;
  const c = document.createElement('canvas');
  c.width = c.height = 128;
  const g = c.getContext('2d')!;
  const grad = g.createRadialGradient(64, 64, 2, 64, 64, 62);
  grad.addColorStop(0, 'rgba(255,255,255,1)');
  grad.addColorStop(0.35, 'rgba(255,255,255,0.6)');
  grad.addColorStop(1, 'rgba(255,255,255,0)');
  g.fillStyle = grad;
  g.fillRect(0, 0, 128, 128);
  glowTex = new THREE.CanvasTexture(c);
  glowTex.colorSpace = THREE.SRGBColorSpace;
  return glowTex;
}

export function makeGlowSprite(color: number, size: number, opacity = 0.95): THREE.Sprite {
  const mat = new THREE.SpriteMaterial({
    map: tex(), color, transparent: true, opacity,
    blending: THREE.AdditiveBlending, depthWrite: false, depthTest: true,
  });
  const s = new THREE.Sprite(mat);
  s.scale.set(size, size, 1);
  s.userData.baseSize = size;
  s.userData.baseOpacity = opacity;
  return s;
}

/** Throb a glow sprite over time (t = seconds). amt 0..1 = depth of the pulse. */
export function pulseGlow(s: THREE.Sprite, t: number, speed = 3, amt = 0.18) {
  const base = s.userData.baseSize as number;
  const k = 1 + Math.sin(t * speed) * amt;
  s.scale.set(base * k, base * k, 1);
  (s.material as THREE.SpriteMaterial).opacity = (s.userData.baseOpacity as number) * (0.85 + 0.15 * Math.sin(t * speed));
}
